module.exports = __webpack_public_path__ + "static/media/news-platform.37e70f46.jpg";